module.exports = __webpack_public_path__ + "media/images/eraser_icon-42964247.svg";